import options from './organization-member-details.component';

export default {
    selector: 'dtOrganizationMemberDetailsPage',
    options
};
